export default __webpack_public_path__ + "static/media/AndroidLogo.8fb4ac51.svg";